module.exports = __webpack_public_path__ + "static/r34-0cb966609ab6b5f02a206a95a612640f.jpg";